import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../redux/ProductReducer';
import InternalContainer from '../../layout/containers/Internal';
import { Loader } from '../../../common/components';
import InsurerHandlerForm from '../components/InsurerHandlerForm/InsurerHandlerForm';
const HandlersContainer = ({
  params,
  getProduct,
  getInsurerHandlers,
  updateHandlers,
}) => {
  const { productId, insurerId } = params;
  const isSchemeGroup = ['FreeSpirit', 'Free2Travel'].includes(insurerId);
  const { product, topLevelArea } = useSelector((state) => state.productManagement);

  const schemes = topLevelArea?.[insurerId]?.schemes;
  const parameters = topLevelArea?.[insurerId]?.parameters;

  const currentProductId = product?.data?.id;
  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
    },
    [productId, currentProductId, getProduct],
  );

  useEffect(
    () => {
      getInsurerHandlers(insurerId, isSchemeGroup);
    },
    [insurerId, isSchemeGroup, getInsurerHandlers],
  );

  const update = (formValues) => {
    const schemesToUpdate = formValues?.meta?.schemes?.filter((scheme) => {
      return scheme.enabled;
    });
    const values = {
      ...formValues,
      meta: {
        ...formValues.meta,
        schemes: schemesToUpdate,
      },
    };
    updateHandlers(values, isSchemeGroup);
  };

  if (!parameters || !schemes) {
    return (
      <InternalContainer title={'Assistance / Claims Handler'}>
        <Loader />
      </InternalContainer>
    );
  }

  const values = {
    data: {
      attributes: {
        metadata: {
          claims_handlers: parameters.claimsHandlerInfo || [],
          assistance_handlers: parameters.assistanceHandlerInfo || [],
        },
      },
      relationships: {
        claims_handler: {
          data: {
            id: '',
          },
        },
        assistance_handler: {
          data: {
            id: '',
          },
        },
      },
    },
    meta: {
      schemes: schemes?.map((scheme) => ({
        ...scheme,
        update: false,
      })),
    },
  };

  return (
    <InternalContainer title={'Assistance / Claims Handler'}>
      <InsurerHandlerForm
        values={values}
        claimsHandler={parameters.assignedClaimsHandler?.name}
        assistanceHandler={parameters.assignedAssistanceHandler?.name}
        schemesToUpdate={schemes}
        onUpdate={update}
      />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
    getInsurerHandlers: actions.getInsurerHandlers,
    updateHandlers: actions.updateHandlers,
  },
)(HandlersContainer);
